import { Tag, theme } from 'antd';

/**
 * A etiqueta que aponta a porta usada na última vez.
 *
 * **Sólida, e não a variante clara padrão do Antd v6.** O trabalho dela é ser
 * vista de relance por quem já abriu a tela dezenas de vezes e não lê mais nada
 * nela; em fundo pálido com texto colorido ela some dentro do botão, e uma
 * etiqueta que ninguém nota não economiza tentativa nenhuma. É a mesma escolha
 * da Voa, que usa a marca cheia com texto branco.
 *
 * Existe como componente porque aparece em dois lugares - no botão do Google e
 * dentro do campo de e-mail - e o par tem de ser idêntico: duas etiquetas com o
 * mesmo texto e pesos diferentes leriam como duas coisas diferentes.
 */
export function EtiquetaDaUltimaVez() {
  const { token } = theme.useToken();

  return (
    <Tag
      variant="solid"
      color={token.colorPrimary}
      style={{
        marginInlineEnd: 0,
        fontSize: token.fontSizeSM,
        /*
         * Aperto lateral menor que o do Antd. São doze pixels a menos, e é o
         * que faz o conjunto símbolo + rótulo + etiqueta caber nos 288px do
         * botão num celular de 320: com o padrão, faltavam oito.
         */
        paddingInline: token.paddingXXS,
        /*
         * A tinta é a **cor do fundo da página**, e o par se resolve sozinho nos
         * dois temas: no claro, branco sobre o verde escuro da marca; no escuro,
         * o quase preto do fundo sobre o verde clarinho que o tema usa ali.
         *
         * Não é preciosismo. O branco que o Antd põe por padrão em etiqueta
         * sólida dá **3,2 de contraste** sobre o verde do modo escuro - a WCAG
         * pede 4,5 para texto deste tamanho -, e a etiqueta que existe para ser
         * notada era justamente a peça ilegível da tela. Medido depois da
         * troca: 5,92 no claro e 5,73 no escuro.
         */
        color: token.colorBgContainer,
      }}
    >
      Da última vez
    </Tag>
  );
}
